import React from "react";
import { Link } from "react-router-dom";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableSortLabel,
} from "@material-ui/core";

import { useStore } from "@store/store";
import Pagination from "@components/pagination";
import Loader from "@components/loader";
import {
  dashboardRequestStatusColors,
  utcToLocal,
  getUserData,
  formatNetCharge
} from "@utils/commonFunctions";
import { dashboardListingHeader, routes, dashboardInterstateListingHeader, jobStatus } from "@utils/constant";
import { TableStyle } from "./style";

function TableListing(props) {
  const classes = TableStyle();
  const [state] = useStore();

  return (
    <>
      <div className={classes.TableWrapper}>
        <Loader loading={state.job?.loadingJobs || state.job?.loadingInterstateJobs} />
        <TableContainer component={Paper} className={classes.customTable}>
          <Table stickyHeader aria-label="simple table">
            <TableHead>
              <TableRow>
                {(props.isInterstate ? dashboardInterstateListingHeader : dashboardListingHeader).map((item, index) => {
                  if (item.title !== "Customer" || getUserData()?.connectedCustomer) {
                    return (
                      <TableCell key={index} className={item.className}>
                        {item.title}
                        {item.sort && (
                          <TableSortLabel
                            direction={
                              props.orderBy === item.sortTitle
                                  ? props.order
                                  : "desc"
                            }
                            active={true}
                            onClick={(e) => props.handleSorting(e, item)}
                          ></TableSortLabel>
                        )}
                      </TableCell>
                    );
                  }
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {(!props.isInterstate ? (state.job?.jobsData) : (state.job?.interstateJobsData))?.count === 0 ? (
                <TableRow className="no-data">
                  <TableCell colSpan={getUserData()?.connectedCustomer ? 8 : props.isInterstate ? 12 : 7}>
                    <span>No Data Found</span>
                  </TableCell>
                </TableRow>
              ) : (
                  (!props.isInterstate ? (state.job?.jobsData?.rows) : (state.job?.interstateJobsData?.rows))?.map((row, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell className="jobId">
                        <Link
                          to={props.isInterstate ? {
                            pathname: `${routes.interstateJobDetail}/${row.id}`,
                            state: row,
                          } : {
                            pathname: `${routes.jobDetail}/${row.id}`,
                            state: row,
                          }}
                        >
                          {row.id ? row.id : "-"}
                        </Link>
                      </TableCell>

                      {getUserData()?.connectedCustomer && !props.isInterstate &&
                        <TableCell className="customer break-word">
                          {row?.customers ? row?.customers?.name : "-"}
                        </TableCell>
                      }
                      {props.isInterstate && (
                        <TableCell>{row?.cities?.name || "-"}</TableCell>)
                      }

                      <TableCell className="driver">
                        {row?.drivers ? row?.drivers?.name : "-"}
                      </TableCell>

                      <TableCell className="truck-rego break-word">
                        {row.trucks ? row.trucks?.rego : "-"}
                      </TableCell>
                      {props.isInterstate && (
                        <TableCell className="trailer break-word">
                          {row?.trailers ? row?.trailers?.rego : "-"}
                        </TableCell>)
                      }
                      {/* https://wymap.atlassian.net/browse/MAPTRAK-931 */}
                      <TableCell
                        className={`status ${dashboardRequestStatusColors(
                          row.jobStatuses ? row.jobStatuses.name : ""
                        )}`}
                      >
                        <span>
                          {row.jobStatuses
                            ? row.jobStatuses.name === "Review Completed"
                              ? "Completed"
                              : row.jobStatuses.name === "Change Driver"
                              ? "In Transit"
                              : row.jobStatuses.name
                            : "-"}
                        </span>
                      </TableCell>
                      {props.isInterstate && (
                        <TableCell className="customerName break-word">
                          {row?.customers ? row?.customers.name : "-"}
                        </TableCell>)
                      }
                      {!props.isInterstate && (
                        <TableCell className="cto break-word">
                          {row.ctos ? row.ctos.name : "-"}
                        </TableCell>)
                      }
                      {!props.isInterstate && (
                        <TableCell className="jobType">
                          {row.jobTypes ? row.jobTypes.name : "-"}
                        </TableCell>)
                      }
                      {!props.isInterstate && (
                        <TableCell className="cargoType">
                          {row.cargoTypes ? row.cargoTypes.name : "-"}
                        </TableCell>)
                      }
                      {props.isInterstate && (
                        <TableCell className="pickUpLocation break-word">
                          {row?.pickUpLocation ? row?.pickUpLocation : "-"}
                        </TableCell>)
                      }
                      {props.isInterstate && (
                        <TableCell className="dropOffLocation break-word">
                          {row?.dropOffLocation ? row?.dropOffLocation : "-"}
                        </TableCell>)
                      }
                      <TableCell className="date">
                        {row.createdAt
                          ? utcToLocal(
                              row.createdAt,
                              row.cities?.timezone,
                              "DD/MM/YYYY"
                            )
                          : "-"}
                      </TableCell>
                      {props.isInterstate && (
                        <TableCell className="net-charge">
                          {row.net
                            ? `$${formatNetCharge(row.net)}`
                            : "-"}
                        </TableCell>)
                      }
                      <TableCell className="completion-date">
                        {row.completedAt
                          ? utcToLocal(
                              row.completedAt,
                              row.cities?.timezone,
                              "DD/MM/YYYY"
                            )
                          : "-"}
                      </TableCell>
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {(!props.isInterstate ? state.job?.jobsData : state.job?.interstateJobsData)?.count !== 0 && (
          <div className="pagination-wrapper">
            <Pagination
              count={!props.isInterstate ? state.job?.jobsData?.count : state.job?.interstateJobsData?.count}
              page={props.page}
              handleChangePage={props.handleChangePage}
              rowsPerPage={props.rowsPerPage}
              handleChangeRowsPerPage={props.handleChangeRowsPerPage}
            />
          </div>
        )}
      </div>
    </>
  );
}
export default TableListing;
